import React from "react";
import { Placeholder } from "../components/placeholder/placeholder";
import { IRectangle } from "../types/layout";

// LayoutStyle represents how the application is laid out given the space available.
export declare type LayoutStyle = "mobile" | "tablet" | "desktop";

/**
 * Used to get the window size, used to determine the layout
 */
export function getLayoutStyle(): LayoutStyle {
  const { innerWidth } = window;
  return innerWidth < 640 ? "mobile" : innerWidth < 1024 ? "tablet" : "desktop";
}

/**
 * Used to check if document.fullscreenElement is supported in the user's browser
 */
export function fullscreenSupported(): boolean {
  return document.fullscreenElement !== undefined && window === window.top;
}

/**
 * Default placeholder element for layouts if ILayoutOptions.renderPlaceholder is not provided
 * @param tileRect The tile's position and size
 * @param index The index of the tile in this tile set
 * @returns A placeholder element with the given dimensions
 */
export const renderDefaultPlaceholder = (tileRect: IRectangle, index: number): React.ReactElement => {
  return <Placeholder className="absolute" key={`placeholder-${index}`} rect={tileRect} />;
};
